export const getAlertTitle = (statusCode: number) => {
    const codeHundred = Math.floor(statusCode / 100)

    if (codeHundred === 5) {
        return 'An Error Occurred'
    }
    if (codeHundred === 4) {
        if (statusCode === 403) {
            return 'You don’t have an access'
        }
        return 'You cannot continue because:'
    }
    return undefined
}

export const getDefaultErrorMessage = (statusCode: number) => {
    if (statusCode === 403) {
        return 'If you need access, please contact IT'
    }
    if (statusCode === 500) {
        return 'Something went wrong. \n If problem remains, please contact IT'
    }
    return undefined
}
